module.exports = __webpack_public_path__ + "img/LV1.3b25cc20.svg";